




































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";

import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Table from "@/components/Common/Table.vue";
import { IPagination, ITableParams, IUser } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    AlertBox,
    Table
  }
})
export default class Users extends Vue {
  public loading = false;
  public updating = false;
  private users: Array<IUser> = [];
  private failedRequest = false;
  private selectedUserId: string | null = null;
  private componentKey = 0;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.user_deleted === "true") {
        swal("Success!", "The user was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getUsers(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.user_deleted === "true") {
      swal("Success!", "The user was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    this.getUsers(() => {
      //
    });
    next();
  }

  private getUsers(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.users = [];
    const endpoint: string = this.$partnerEndpoint("users");

    Api()
      .get(endpoint, { params: this.fetchParams })
      .then((response: AxiosResponse) => {
        this.users = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteUser(userId: string): void {
    this.selectedUserId = userId;
    if (this.loading || this.updating || this.selectedUserId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The user will be deleted and will not be able to use his account",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "users/" + this.selectedUserId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "UsersOverview",
                query: { user_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The user was deleted.", "success");
                  this.getUsers(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete users.",
                icon: "error"
                //dangerMode: true,
              });
            }
            if (error.response.status === 409) {
              swal({
                title: "Your own account",
                text: "You cannot delete your own account.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
